import { useEffect, useMemo, useState } from "react";
import AnimatedList from "../ui/AnimatedList";
import { SortModal } from "./SortModal";

// Hardcoded SVG icons for each region
export const RegionIcon = ({ regionName }) => {
	const getRegionIcon = (name) => {
		switch (name) {
			case "Restricted Area":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 51 77"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M25.7386 75.9005C39.1912 75.9005 50.0973 64.9591 50.0973 51.4627V0.809906H1.37988V51.4489C1.37988 64.9452 12.2859 75.8866 25.7386 75.8866V75.9005Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Low Post / Low Block (Right)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 44 96"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M43.2511 0.809906V45.631C43.2511 51.4072 42.4899 57.0029 41.0505 62.3209C37.5489 75.3173 30.0337 86.6753 19.9304 94.9786L1.12158 63.1817C3.01769 59.6966 4.09723 55.7116 4.09723 51.4627V0.809906H43.2511Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Low Post / Low Block (Left)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 44 97"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M24.5607 94.9786L43.3695 63.1817C41.4734 59.6966 40.3938 55.7116 40.3938 51.4627V0.809906H1.23999V45.631C1.23999 65.5283 10.333 83.2874 24.5607 94.9647V94.9786Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "High Post / Elbow (Left)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 75 89"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M73.5947 40.7129L59.4362 88.0888C55.2703 86.3948 51.312 84.5204 47.5336 82.4792C26.1229 70.9546 10.8572 54.6535 1.47351 42.4069L42.4266 1.32086C45.9282 14.3173 53.4434 25.6753 63.5467 33.9786C64.3217 34.6173 65.1106 35.2283 65.9134 35.8392C68.3492 37.6304 70.9097 39.2688 73.5947 40.7129Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Top of the Key":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 91 59"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M90.0411 49.0888C77.142 54.3235 62.3884 57.6698 45.7387 57.6698C29.089 57.6698 14.3492 54.3235 1.43628 49.0888L15.5948 1.71289C24.5632 6.58656 34.8326 9.34969 45.7387 9.34969C56.6447 9.34969 66.9141 6.58656 75.8826 1.71289L90.0411 49.0888Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Wing (Mid-Range) Left":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 54 105"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M1.19385 0.809906V86.2727C1.19385 86.2727 4.91686 93.5207 12.4736 103.407L53.4267 62.3209C51.9873 57.0029 51.2261 51.4072 51.2261 45.631V0.809906H1.19385Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "High Post / Elbow (Right)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 74 89"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M73.0037 42.4069C63.6339 54.6535 48.3682 70.9546 26.9575 82.4792C23.1791 84.5065 19.207 86.3948 15.0411 88.0888L0.882568 40.7129C3.56756 39.2688 6.14183 37.6304 8.5777 35.8253C9.38043 35.2283 10.1555 34.6034 10.9305 33.9786C21.0339 25.6753 28.5491 14.3173 32.0507 1.32086L73.0037 42.4069Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Wing (Mid-Range) Right":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 54 105"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M53.2833 0.809906V86.2727C53.2833 86.2727 49.5603 93.5207 42.0036 103.407L1.05054 62.3209C2.40687 57.3222 3.15425 52.0876 3.23729 46.6724C3.23729 46.3252 3.23729 45.9781 3.23729 45.631V0.809906H53.2695H53.2833Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Top of the Key 3":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 224 141"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M222.432 139.761H1.05872L55.5336 1.47925C59.312 3.52036 63.2703 5.39485 67.4362 7.08883C80.3491 12.3235 95.1027 15.6698 111.739 15.6698C128.374 15.6698 143.142 12.3235 156.041 7.08883C160.207 5.39485 164.179 3.50647 167.957 1.47925L222.432 139.761Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="8"
						/>
					</svg>
				);
			case "Wing 3 (Left)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 77 202"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M1.39185 13.9786V200.761H21.0449L75.5198 62.4793C54.1091 50.9546 38.8434 34.6535 29.4736 22.4069C21.9168 12.5207 18.1938 5.27267 18.1938 5.27267V1.84305L1.39185 13.9786Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="8"
						/>
					</svg>
				);
			case "Corner 3 (Left)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 19 96"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M1.39185 0.809906V94.9786L18.1938 82.843V0.809906H1.39185Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Wing 3 (Right)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 76 202"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M75.0853 13.9786V200.761H55.4322L0.957275 62.4792C22.368 50.9546 37.6337 34.6535 47.0035 22.4069C54.5603 12.5207 58.2833 5.27267 58.2833 5.27267V1.84305L75.0853 13.9786Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="8"
						/>
					</svg>
				);
			case "Corner 3 (Right)":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 19 96"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M18.0854 0.809906V94.9786L1.28345 82.843V0.809906H18.0854Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="4"
						/>
					</svg>
				);
			case "Short Corner / Baseline":
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 83 48"
						fill="none"
						className="text-color-Grey450"
					>
						<path
							d="M81.1434 32.8862C80.3671 33.5127 79.5908 34.1391 78.7867 34.7377C77.4421 35.74 76.0419 36.6867 74.6141 37.5776C74.1012 37.8978 73.5883 38.218 73.0754 38.5103C72.41 38.9001 71.7445 39.276 71.0791 39.6379C62.0962 44.5242 51.8102 47.2945 40.8864 47.2945C37.4762 47.2945 34.1215 47.0161 30.8499 46.501C30.1707 46.3897 29.4914 46.2783 28.8121 46.1391C27.814 45.9581 26.8298 45.7354 25.8455 45.4987C25.1108 45.3177 24.3761 45.1228 23.6414 44.914C22.8651 44.6913 22.0888 44.4546 21.3125 44.204C19.4688 43.6054 17.6528 42.9233 15.8783 42.1576C15.4347 41.9767 14.9911 41.7818 14.5614 41.573C13.2445 40.9604 11.9691 40.3061 10.6937 39.624C10.2501 39.3874 9.80654 39.1368 9.36293 38.8862C8.91933 38.6356 8.48959 38.385 8.05985 38.1205C7.18651 37.6055 6.34089 37.0625 5.49527 36.4918C5.10712 36.2412 4.71897 35.9767 4.33082 35.6983C4.24764 35.6565 4.17833 35.6008 4.09515 35.5312C3.33271 34.9744 2.57027 34.4175 1.82169 33.8329C1.41968 33.5266 1.03152 33.2203 0.643372 32.8862L19.4826 1.00702C19.5381 1.10447 19.5797 1.20191 19.649 1.28544C19.8292 1.63347 20.0371 1.96757 20.2589 2.30168C20.3144 2.42697 20.3837 2.53833 20.4669 2.63578C20.7441 3.06733 21.0352 3.49889 21.3402 3.9026C21.6175 4.29239 21.9086 4.65433 22.2135 5.00236C24.2098 7.4107 26.6773 9.42926 29.4637 10.891C29.7132 11.0441 29.9627 11.1833 30.24 11.2947C30.2816 11.3225 30.3232 11.3364 30.3647 11.3504C30.6697 11.5174 30.9747 11.6566 31.2935 11.7819C31.6817 11.949 32.0837 12.116 32.4857 12.2552C33.2204 12.5476 33.9967 12.7842 34.773 12.9791C35.1612 13.0905 35.5493 13.174 35.9514 13.2436C36.3534 13.3411 36.7554 13.4107 37.1574 13.4664C37.5594 13.536 37.9614 13.5917 38.3773 13.6195C38.7793 13.6752 39.1952 13.703 39.6111 13.7169C40.027 13.7448 40.4428 13.7587 40.8726 13.7587C41.3439 13.7587 41.8152 13.7448 42.2866 13.7169C42.3836 13.7169 42.4806 13.7169 42.5777 13.6891C42.9797 13.6752 43.3817 13.6334 43.7699 13.5777C43.8253 13.5777 43.8669 13.5777 43.9223 13.5638C44.255 13.522 44.5878 13.4803 44.9205 13.4246C45.17 13.3828 45.4334 13.3272 45.6829 13.2854C46.0156 13.2158 46.3622 13.1462 46.6949 13.0626C47.0137 12.9791 47.3325 12.8956 47.6514 12.7982C48.2059 12.645 48.7327 12.464 49.2594 12.2692C49.5506 12.1717 49.8417 12.0603 50.1189 11.935C50.2437 11.8933 50.3546 11.8376 50.4655 11.7958C50.6734 11.7123 50.8675 11.6149 51.0616 11.5313C51.3111 11.42 51.5468 11.3086 51.7824 11.1833C51.9072 11.1137 52.0181 11.058 52.129 11.0023C52.4201 10.8492 52.7112 10.6961 53.0023 10.5151C54.5549 9.62415 56.0105 8.55223 57.3136 7.35502C57.5493 7.1462 57.7849 6.92347 58.0067 6.68681C58.9217 5.79586 59.7534 4.82139 60.502 3.79123C60.7238 3.51281 60.9179 3.23439 61.0981 2.95597C61.306 2.6497 61.5001 2.34344 61.6942 2.03718C61.7496 1.93973 61.8051 1.8562 61.8605 1.75876C61.9991 1.5221 62.1516 1.2576 62.2903 1.00702L81.1295 32.8862H81.1434Z"
							className="fill-color-background-grey-2 stroke-current"
							strokeMiterlimit="10"
							strokeWidth="3"
						/>
					</svg>
				);
			default:
				return (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						className="text-color-Grey450"
					>
						<rect
							x="4"
							y="4"
							width="16"
							height="16"
							rx="2"
							className="fill-color-background-grey-2 stroke-current"
							strokeWidth="4"
						/>
					</svg>
				);
		}
	};

	return getRegionIcon(regionName);
};

// Module-level variable to persist state during the session (resets on reload)
let sessionExpandedState = false;

export const RegionViewBottom = ({
	shootingStats,
	regionStats,
	onRegionClick,
}) => {
	const sortOptions = ["percentage", "total", "totalPoints"];
	const sortLabels = {
		percentage: "Percentage",
		total: "Attempts",
		totalPoints: "Scores",
	};
	const [selectedSortKey, setSelectedSortKey] = useState("percentage");
	const [showSortModal, setShowSortModal] = useState(false);

	// Initialize from session variable so it persists across unmounts but resets on reload
	const [isExpanded, setIsExpanded] = useState(sessionExpandedState);

	// Update session variable whenever state changes
	useEffect(() => {
		sessionExpandedState = isExpanded;
	}, [isExpanded]);

	const handleSortClick = () => {
		setShowSortModal(true);
	};

	const handleApply = (newSortKey) => {
		setSelectedSortKey(newSortKey);
		setShowSortModal(false);
	};

	const sortedRegionStats = useMemo(() => {
		return [...regionStats].sort(
			(a, b) => b[selectedSortKey] - a[selectedSortKey],
		);
	}, [regionStats, selectedSortKey]);

	// Display 6 entries by default with expand button in the middle (after 3rd entry), show all when expanded
	const hasMoreRegions = sortedRegionStats.length > 6;
	const displayedRegions = isExpanded
		? sortedRegionStats
		: sortedRegionStats.slice(0, Math.min(6, sortedRegionStats.length));

	// Transform regions into renderable items for AnimatedList
	const listItems = useMemo(() => {
		const items = [];

		displayedRegions.forEach((region, index) => {
			// Add region item
			items.push(
				<div
					key={`region-${region.name}`}
					className="flex items-center justify-between p-3 rounded-lg bg-gray-100 cursor-pointer hover:bg-gray-200 transition-colors"
				>
					<div className="flex items-center gap-3">
						<RegionIcon regionName={region.name} />
						<div className="text-sm font-medium text-gray-700">
							{region.name}
						</div>
					</div>
					<div className="text-sm text-gray-800">
						<span className="font-bold text-gray-900">
							{region.percentage}%
						</span>
						<span className="text-xs text-gray-600 ml-1">
							({region.made}/{region.total})
						</span>
					</div>
				</div>,
			);

			// Add expand button after 3rd entry if needed
			if (hasMoreRegions && index === 2 && !isExpanded) {
				items.push(
					<button
						key="expand-button"
						onClick={(e) => {
							e.stopPropagation();
							setIsExpanded(true);
						}}
						className="w-full py-1.5 bg-color-Black text-color-White text-sm font-medium rounded transition-colors hover:bg-gray-800 flex items-center justify-center gap-2"
					>
						<span>Expand</span>
					</button>,
				);
			}
		});

		return items;
	}, [displayedRegions, hasMoreRegions, isExpanded]);

	return (
		<div className="box-border w-full bg-white flex flex-col justify-center px-3">
			<div
				className="mb-3 text-left cursor-pointer flex items-center"
				onClick={handleSortClick}
			>
				<span className="text-white text-sm leading-[1.2] ml-1.5 px-2.5 py-1 bg-black rounded">
					<span className="inline-flex items-center gap-1">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							className="shrink-0"
						>
							<path
								d="M13.3333 2.66669V10.6667H15.3333L12.6667 14L10 10.6667H12V2.66669H13.3333ZM8 12V13.3334H2V12H8ZM9.33333 7.33335V8.66669H2V7.33335H9.33333ZM9.33333 2.66669V4.00002H2V2.66669H9.33333Z"
								className="fill-current text-white"
							/>
						</svg>
						<span>Sort by:</span>
						<span className="font-semibold">{sortLabels[selectedSortKey]}</span>
					</span>
				</span>
				<svg
					className="w-4 h-4 ml-1 text-gray-500"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M8 9l4-4 4 4m0 6l-4 4-4-4"
					/>
				</svg>
			</div>

			<AnimatedList
				items={listItems}
				onItemSelect={(_item, index) => {
					// Find the corresponding region (excluding expand button)
					const regionIndex =
						index > 3 && hasMoreRegions && !isExpanded ? index - 1 : index;
					if (regionIndex < displayedRegions.length && onRegionClick) {
						onRegionClick(displayedRegions[regionIndex]);
					}
				}}
				showGradients={false}
				enableArrowNavigation={true}
				displayScrollbar={false}
				itemSpacing="mb-2"
				className="!w-full !max-h-[340px] !p-0"
				itemClassName="!p-0 !bg-transparent"
			/>

			<SortModal
				show={showSortModal}
				onClose={() => setShowSortModal(false)}
				sortOptions={sortOptions}
				sortLabels={sortLabels}
				selectedSort={selectedSortKey}
				onApply={handleApply}
			/>
		</div>
	);
};
